import { useCallback, useRef, useState } from 'react';
import { ToastMessageLevel, ToastProps } from 'views/components/atoms/toast';

export const useToast = () => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const [toastLabel, setToastLabel] = useState<string>('');
  const [messageLevel, setMessageLevel] = useState<ToastMessageLevel>(ToastMessageLevel.Info);
  const timeoutIdRef = useRef<ReturnType<typeof setTimeout>>();

  const toastProps: ToastProps = {
    isActive: isActive,
    label: toastLabel,
    messageLevel,
    setIsActive,
  };

  const showToast = useCallback((label: string, messageLevel: ToastMessageLevel, selfCloseOnly = false) => {
    // 連続で呼ばれた場合に意図せずに非表示になるのでclearTimeoutする
    clearTimeout(timeoutIdRef.current);

    setToastLabel(label);
    setMessageLevel(messageLevel);
    setIsActive(true);
    if (messageLevel !== ToastMessageLevel.Error && !selfCloseOnly) {
      timeoutIdRef.current = setTimeout(() => {
        setIsActive(false);
      }, 4000);
    }
  }, []);

  const hideToast = useCallback(() => {
    setIsActive(false);
  }, []);

  return {
    toastProps,
    showToast,
    hideToast,
  };
};
